import React from 'react'
import Sidebar from '../../componente/sidebar';
import { useAppContext } from '../../context/AppContext.js';
import api from '../../services/api.js';
import "./style.css";
import { useEffect } from "react";

function Principal() {
    const { companies, selectedCompany, user, setLicenca } = useAppContext(); // Acessa os dados do contexto

    function VerificaLicenca() {
        if (selectedCompany > 0) {
            api.get("v1/principal/licenca", {
                params: {
                    codempresa: selectedCompany
                }
            }).then((response) => {
                if (response.data.dia > 3) {
                    setLicenca(false);
                    alert("Licença venceu, entre em contato com o suporte!")
                } else {
                    setLicenca(true);
                }
            });
        }
    }

    useEffect(
        function () {
            VerificaLicenca();
        },
        [selectedCompany]
    );

    return <>
        <div className="app-container">
            <Sidebar />

            <div className="content-container">
                <div className="container-fluid">
                    <h2>Dados de Acesso</h2>                                    
                    <p>Usuário logado: Seja bem-vindo {user.nome}</p>   
                    <h3>Empresas Vinculadas:</h3>

                    <ul>
                        {companies.map((company, index) => (
                            <li key={index}>{company.razaosocial} - {company.cnpj}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </>
}

export default Principal;